module.exports = __webpack_public_path__ + "static/cello_en-e1c02b0093f01e5d5fc1454e67edbb0e.pdf";